import React, { useState, createContext, useEffect } from 'react'
import { getTierProductIdQueryParamFromHash } from '../helpers/getTierProductIdQueryParamFromHash'

interface PlansContextValues {
  selectedPlanId: number | undefined
  setSelectedPlanId: (selectedPlanId: number | undefined) => void
}

const initialValue: PlansContextValues = {
  selectedPlanId: 0,
  setSelectedPlanId: () => null,
}

export const PlansContext = createContext<PlansContextValues>(initialValue)

export const PlansProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedPlanId, setSelectedPlanId] = useState(
    initialValue.selectedPlanId,
  )

  useEffect(() => {
    if (window) {
      const productId = getTierProductIdQueryParamFromHash()
      if (productId) {
        setSelectedPlanId(productId)
      }
    }
  }, [])

  return (
    <PlansContext.Provider
      value={{
        selectedPlanId,
        setSelectedPlanId,
      }}
    >
      {children}
    </PlansContext.Provider>
  )
}
